module.exports = __webpack_public_path__ + "img/pump-medical.265990b8.svg";